import { createContext, useContext, useState, ReactNode } from 'react'

interface PifOverlayContextType {
  isOpen: boolean
  openOverlay: () => void
  closeOverlay: () => void
}

const PifOverlayContext = createContext<PifOverlayContextType | undefined>(undefined)

export function PifOverlayProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openOverlay = () => setIsOpen(true)
  const closeOverlay = () => setIsOpen(false)

  return (
    <PifOverlayContext.Provider value={{ isOpen, openOverlay, closeOverlay }}>{children}</PifOverlayContext.Provider>
  )
}

export function usePifOverlay() {
  const context = useContext(PifOverlayContext)
  if (context === undefined) {
    throw new Error('usePifOverlay must be used within a PifOverlayProvider')
  }
  return context
}
